@if (replacementProduct$ | async; as replacementProduct) {
  @if (isProductDiscontinuedInRegion) {
    <section class="container">
      <div class="row replacement-product-panel mt-3 mb-5">
        <mat-accordion class="col">
          <mat-expansion-panel [expanded]="panelOpenState">
            <mat-expansion-panel-header>
              <mat-panel-title class="cx-product-name">Replacement Product</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-12 col-md-3">
                <a
                  [routerLink]="{ cxRoute: 'product', params: replacementProduct } | cxUrl"
                  class="cx-product-image-container"
                  tabindex="-1"
                  >
                  <cx-media
                    class="cx-product-image"
                    [container]="replacementProduct.images?.PRIMARY || replacementProduct.images"
                    [alt]="replacementProduct?.summary"
                  ></cx-media>
                </a>
              </div>
              <div class="col-12 col-md-9">
                @if (replacementProduct.variantOptions) {
                  <cx-variant-style-icons
                    [variants]="replacementProduct.variantOptions"
                  ></cx-variant-style-icons>
                }
                <div class="row">
                  <div class="col-12 col-md-8">
                    <a
                      [routerLink]="{ cxRoute: 'product', params: replacementProduct } | cxUrl"
                      class="cx-product-name"
                      [innerHtml]="replacementProduct.nameHtml || replacementProduct.name"
                    ></a>
                    @if (replacementProduct.code) {
                      <p class="cx-product-code">{{ replacementProduct?.code }}</p>
                    }
                    @if (userPermissionService.showPrice) {
                      <div class="cx-product-price" aria-label="Product price">
                        {{ replacementProduct.price?.formattedValue }}
                      </div>
                    }
                    <p class="cx-product-summary" [innerHtml]="replacementProduct.summary">
                      {{ replacementProduct.summary }}
                    </p>
                  </div>
                  <div class="col-12 col-md-4">
                    @if (userPermissionService.addToCart) {
                      <app-custom-add-to-cart
                        [showQuantity]="false"
                        [product]="replacementProduct"
                      ></app-custom-add-to-cart>
                    }
                    <button
                      class="btn btn-block btn-light w-100 border border-secondary mt-2"
                      [routerLink]="{ cxRoute: 'product', params: replacementProduct } | cxUrl"
                      >
                      View product
                    </button>
                    @if (compare) {
                      <mat-slide-toggle
                        class="top-margin mt-2"
                        appCompare
                        [productToCompare]="replacementProduct"
                        >
                        Add to compare
                      </mat-slide-toggle>
                    }
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </section>
  }
}
